/**
 * CANONICAL INPUT LIMITS — single source of truth for the frontend (spec A3).
 *
 * These MUST mirror the on-chain constants in TokenFactory.sol:
 *   MAX_NAME_BYTES   = 50
 *   MAX_SYMBOL_BYTES = 12
 *   MAX_SUPPLY       = 10**33  (1e15 whole tokens at 18 decimals)
 *
 * IMPORTANT: name/symbol limits are UTF-8 BYTE limits, not character counts.
 * The frontend must count encoded bytes (see byteLength helper), because a
 * single character like "é" or an emoji is 2–4 bytes and the contract measures
 * bytes. A contract test asserts these values equal the deployed constants so
 * the two sources cannot silently drift.
 */
export const TOKEN_DECIMALS = 18n;

export const MAX_NAME_BYTES = 50;
export const MIN_NAME_BYTES = 1;
export const MAX_SYMBOL_BYTES = 12;
export const MIN_SYMBOL_BYTES = 1;

/** Max supply in SMALLEST units (must equal on-chain MAX_SUPPLY). */
export const MAX_SUPPLY_SMALLEST_UNITS = 10n ** 33n;
/** Max supply expressed in WHOLE tokens, for human-facing validation. */
export const MAX_SUPPLY_WHOLE_TOKENS = MAX_SUPPLY_SMALLEST_UNITS / 10n ** TOKEN_DECIMALS;

/** UTF-8 byte length of a string (what the contract actually measures). */
export function byteLength(value: string): number {
  return new TextEncoder().encode(value).length;
}
